import { TerumLogo } from './TerumLogo';

export const nextStep = (current: number, total: number) => Math.min(current + 1, total - 1);
export const prevStep = (current: number) => Math.max(current - 1, 0);

interface WizardStep { id: string; title: string; sub?: string; panel: React.ReactNode; }
interface WizardProps {
  steps: WizardStep[];
  current: number;
  // Optional: onboarding drives navigation from in-panel buttons, so its rail is
  // display-only. When provided, rail steps are clickable (free navigation).
  onGoto?: (i: number) => void;
  brand?: string;
  // Toggles the team-step self/invite CSS fork (overhaul.css:322-323).
  dataEntry?: 'self' | 'invite';
}

// The .wiz rail+panel shell (overhaul §6.2): a left progress rail + the single active
// panel. Done steps (i < current) show a ✓; the active step its number.
export function Wizard({ steps, current, onGoto, brand, dataEntry }: WizardProps) {
  return (
    <div className="wiz" data-entry={dataEntry}>
      <nav className="wiz-rail">
        {brand && <div className="wiz-brand"><span style={{ color: 'var(--acc)', display: 'inline-flex' }}><TerumLogo size={18} /></span>{brand}</div>}
        {steps.map((s, i) => {
          const done = i < current;
          const active = i === current;
          return (
            <div
              key={s.id}
              className={`wiz-step${active ? ' active' : ''}${done ? ' done' : ''}`}
              onClick={onGoto ? () => onGoto(i) : undefined}
              style={onGoto ? undefined : { cursor: 'default' }}
            >
              <span className="wn">{done ? '✓' : i + 1}</span>
              <div>
                <div className="wt">{s.title}</div>
                {s.sub && <div className="ws">{s.sub}</div>}
              </div>
            </div>
          );
        })}
      </nav>
      <section className="wiz-main">
        <div className="wiz-panel active">{steps[current]?.panel}</div>
      </section>
    </div>
  );
}
